<template>
    <blockquote v-if="slice.primary.quote" class="NewsPostQuotePullout">
        <PrismicRichText :field="slice.primary.quote" />
        <footer v-if="slice.primary.who_said_it" class="NewsPostQuotePullout__footer">—
            {{ slice.primary.who_said_it }}
        </footer>
    </blockquote>
</template>

<script setup lang="ts">
import { type Content } from '@prismicio/client'

// The array passed to `getSliceComponentProps` is purely optional.
// Consider it as a visual hint for you when templating your slice.
defineProps(
    getSliceComponentProps<Content.NewsPostQuotePulloutSlice>([
        'slice',
        'index',
        'slices',
        'context',
    ]),
)
</script>

<style lang="scss">
.NewsPostTextBlock+.NewsPostQuotePullout {
    display: block;
    margin-top: 2rem;
}

.NewsPostQuotePullout {
    @include heading-5;
    display: block;
    background-color: var(--lime-green);
    margin-bottom: 2rem;
    padding: 1rem;

    p:not(:first-child) {
        margin-top: 1rem;
    }
}

.NewsPostQuotePullout__footer {
    @include body-sm;

    font-style: italic;
    margin-top: 1rem;
}
</style>
